import axios from "@/api/api";
import { API_ROUTES } from "@/api/routes";

// ============================================================================
//  authrules.api.js — cliente de /authrules/* (cookie auth, axios)
// ============================================================================

async function post(url, params) {
  try {
    const { data } = await axios.post(url, params || {});
    return data;
  } catch (err) {
    const m =
      err?.response?.data?.message || err?.response?.data?.error || err.message;
    throw new Error(Array.isArray(m) ? m.join(", ") : m || "Error");
  }
}

export const authrulesApi = {
  opciones: (params) => post(API_ROUTES.authrules.opciones, params),
  reglas: (params) => post(API_ROUTES.authrules.reglas, params),
  catalogo: (params) => post(API_ROUTES.authrules.catalogo, params),
  blaster: (params) => post(API_ROUTES.authrules.blaster, params),
  historial: (params) => post(API_ROUTES.authrules.historial, params),
  generar: (params) => post(API_ROUTES.authrules.masivo, params),
};
